import $ from 'jquery'
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'

const theme = $('body').data('page-theme')

const defaultConfig = {
  speed: 500,
  infinite: true,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 7000,
  slidesToShow: 1,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
}

const glyphs = {
  tivoli: {
    previous: `
      <svg xmlns="http://www.w3.org/2000/svg" width="34.51" height="18" viewBox="0 0 34.51 18">
        <line x1="34.5" y1="8.95" x2="8.3" y2="8.95" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
        <polyline points="14.1 1.46 7.6 8.96 14.1 16.55" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
        <polyline points="7.9 1.46 1.3 8.96 7.9 16.55" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
      </svg>`,
    next: `
      <svg xmlns="http://www.w3.org/2000/svg" width="34.51" height="18" viewBox="0 0 34.51 18">
        <line y1="9.01" x2="26.21" y2="9.01" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
        <polyline points="20.36 16.59 26.95 9.01 20.36 1.42" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
        <polyline points="26.6 16.59 33.19 9.01 26.6 1.42" fill="none" stroke="#ff2045" stroke-miterlimit="10" stroke-width="1.5"/>
      </svg>`,
  },
  princess: {
    previous: `
      <svg class='arrow-svg' xmlns="http://www.w3.org/2000/svg" width="80" height="20" viewBox="0 0 80 20">
        <path d="M0.2,9.5c-0.3,0.3-0.3,0.7,0,1L4.7,15c0.3,0.3,0.7,0.3,1,0c0.3-0.3,0.3-0.7,0-1l-4-4l4-4c0.3-0.3,0.3-0.7,0-1	c-0.3-0.3-0.7-0.3-1,0L0.2,9.5z M79.3,9.3H0.7v1.4h78.6V9.3z"></path>
      </svg>`,
    next: `
      <svg class='arrow-svg' xmlns="http://www.w3.org/2000/svg" width="80" height="20" viewBox="0 0 57 8">
        <path d="M56.3536 4.35355C56.5488 4.15829 56.5488 3.84171 56.3536 3.64645L53.1716 0.464466C52.9763 0.269204 52.6597 0.269204 52.4645 0.464466C52.2692 0.659728 52.2692 0.976311 52.4645 1.17157L55.2929 4L52.4645 6.82843C52.2692 7.02369 52.2692 7.34027 52.4645 7.53553C52.6597 7.7308 52.9763 7.7308 53.1716 7.53553L56.3536 4.35355ZM0 4.5H56V3.5H0V4.5Z"></path>
      </svg>`,
  },
  openseason: {
    previous: `
    <svg width="33" height="8" viewBox="0 0 33 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.146447 4.03553C-0.0488155 3.84027 -0.0488155 3.52369 0.146447 3.32843L3.32843 0.146447C3.52369 -0.0488155 3.84027 -0.0488155 4.03553 0.146447C4.2308 0.341709 4.2308 0.658291 4.03553 0.853553L1.70711 3.18198H32.5V4.18198H1.70711L4.03553 6.51041C4.2308 6.70567 4.2308 7.02225 4.03553 7.21751C3.84027 7.41278 3.52369 7.41278 3.32843 7.21751L0.146447 4.03553Z" fill="currentColor"/>
    </svg>`,
    next: `
    <svg width="33" height="8" viewBox="0 0 33 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M32.3536 3.32824C32.5488 3.5235 32.5488 3.84008 32.3536 4.03534L29.1716 7.21732C28.9763 7.41259 28.6597 7.41259 28.4645 7.21732C28.2692 7.02206 28.2692 6.70548 28.4645 6.51022L30.7929 4.18179L-2.78178e-07 4.18179L-3.656e-07 3.18179L30.7929 3.18179L28.4645 0.853362C28.2692 0.6581 28.2692 0.341518 28.4645 0.146255C28.6597 -0.0490068 28.9763 -0.0490069 29.1716 0.146255L32.3536 3.32824Z" fill="currentColor"/>      
    </svg>
    `,
  },
}

const $slides = $('[data-header-slides]')

export function init(site = 'tivoli') {
  const previous = `<button type="button" data-role="none" class="slide-control previous stroke-${
    site === 'tivoli' ? 'theme' : theme
  }" aria-label="Previous" tabindex="0" role="button">${glyphs[site].previous}</button>`
  const next = `<button type="button" data-role="none" class="slide-control next stroke-${
    site === 'tivoli' ? 'theme' : theme
  }" aria-label="Next" tabindex="0" role="button">${glyphs[site].next}</button>`
  $slides.each((i, elem) => {
    const $container = $(elem)
    let $config = {}
    $config = $container.data('header-slides-config')

    $container
      .on('init', function (event, slick) {
        $container.find('.page-header').on('click', (event) => {
          if (!$(event.target).hasClass('button')) slick.slickNext()
        })
        $container.on('click', (event) => {
          slick.slickNext()
        })
      })
      .on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $container.addClass('transitioning')
      })
      .on('afterChange', function (event, slick, breakpoint) {
        setTimeout(() => $container.removeClass('transitioning'), 300)
      })
      .slick({
        ...{ ...defaultConfig, ...$config },
        prevArrow: previous,
        nextArrow: next,
      })
  })
}
